import React from "react";
import { Grid } from "@mui/material";

import { formatMonetary, timeStampToDate } from "../../../../utils/formats";
import Table from "../../subcomponents/Table";

const style = {
  justify: "center",
};

const columns = [
  { id: "empresaId", name: "Empresa", style },
  { id: "dataEmissaoInPtBr", name: "Emissão Cont.", style },
  { id: "contrato", name: "Contrato", style },
  { id: "parcela", name: "Parcela", style },
  { id: "dataVencimento", name: "Vencimento", render: timeStampToDate, style },
  {
    id: "valorPrestacao",
    name: "Valor prestação",
    render: formatMonetary,
    style,
  },
  { id: "valorPago", name: "Valor pago", render: formatMonetary, style },
  { id: "diasAtraso", name: "Dias em atraso", style },
  { id: "numeroNotaFiscal", name: "Nota Fiscal", style },
  { id: "pedidoId", name: "Pedido", style },
  { id: "ordemServicoId", name: "OS", style },
];

const AtrasosFinanceiraSection = (props) => {
  const { clienteAtrasoFinanceiraLoading, clienteAtrasoFinanceira } = props;

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Table
            loading={clienteAtrasoFinanceiraLoading}
            noDataMessage="SEM DADOS."
            entries={clienteAtrasoFinanceira}
            columns={columns}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default AtrasosFinanceiraSection;
